import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useState } from "react";
import "./staff_referral.css";
import { Checkbox, RadioButton } from "@progress/kendo-react-inputs";
import DatePicker from "react-datepicker";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import moment from "moment";
import { allStatusConfig, statusConfig } from "./configData";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";

export const Filter = (props) => {


const railPositions = [
  "Assistant Station Manager",
  "Communications Controller",
  "Customer Service Officer",
  "Depot Traffic Controller",
  "Senior/Assistant Engineer",
  "Senior/Technician",
  "Station Manager",
  "Traffic Controller"
];

const busPositions = [
  "Bus Captain (FT)",
  "Bus Captain (PT)",
  "Service Controller",
  "Bus Technician"
];

  const checkDateVali = (type) => {
    if (type === "updatedDate") {
      if (
        props.filterValue.updated_on_start === "" ||
        props.filterValue.updated_on_end === ""
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date, To date should not be empty!
          </div>
        );
      } else if (
        new Date(props.filterValue.updated_on_start) >
        new Date(props.filterValue.updated_on_end)
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date should not be later than To date!
          </div>
        );
      } else {
        return "";
      }
    }

    if (type === "appliedDateDate") {
      if (
        props.filterValue.applied_on_start === "" ||
        props.filterValue.applied_on_end === ""
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date, To date should not be empty!;
          </div>
        );
      } else if (
        new Date(props.filterValue.applied_on_start) >
        new Date(props.filterValue.applied_on_end)
      ) {
        return (
          <div className="Promotion_create_error_text">
            In date range, From date should not be later than To date!;
          </div>
        );
      } else {
        return "";
      }
    }
  };

  return (
    <Dialog width={395} height={"100%"} className="staff_referral_filter_dialog">
      <div className="staff_referral_filter_main_box">
        <div style={{ position: "relative" }}>
          <div
            className="staff_referral_filter_cross_icon"
            onClick={() => props.setShowFilter(false)}
          >
            <span class="k-icon k-font-icon k-i-close k-icon-xl" />
          </div>
        </div>
        <div className="staff_referral_filter_header_box">
          <div className="staff_referral_filter_header_title">Filter</div>
          <div
            className="staff_referral_filter_header_clear_filter"
            onClick={props.filterClearAction}
          >
            Clear Filter
          </div>
        </div>
        <div className="staff_referral_filter_detail_main_box">

          <div className="staff_referral_filter_detail_date_box">
            <div className="staff_referral_filter_detail_title">Applied On</div>
            <div className="staff_referral_filter_radio_button_main_box">
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="appliedOn"
                  value="all"
                  key="all"
                  checked={props.filterValue.appliedDate === "all"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      appliedDate: "all",
                    });
                  }}
                />
                All dates
              </div>
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="appliedOn"
                  value="date"
                  key="date"
                  checked={props.filterValue.appliedDate === "date"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      appliedDate: "date",
                    });
                  }}
                />
                Date Range
              </div>
            </div>
            {props.filterValue.appliedDate === "date" && (
              <div className="staff_referral_filter_detail_date">
                <div className="staff_referral_filter_detail_date_child">
                  <div>From</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.applied_on_start !== ""
                        ? new Date(props.filterValue.applied_on_start)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        applied_on_start: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
                <div className="staff_referral_filter_detail_date_child">
                  <div>To</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.applied_on_end !== ""
                        ? new Date(props.filterValue.applied_on_end)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        applied_on_end: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
              </div>
            )}
            {props.filterValue.appliedDate === "date"
              ? checkDateVali("appliedDate")
              : ""}
          </div>
          <div className="staff_referral_filter_detail_date_box">
            <div className="staff_referral_filter_detail_title">Updated On</div>
            <div className="staff_referral_filter_radio_button_main_box">
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="updatedOn"
                  value="all"
                  key="all"
                  checked={props.filterValue.updatedDate === "all"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      updatedDate: "all",
                    });
                  }}
                />
                All dates
              </div>
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="updatedOn"
                  value="date"
                  key="date"
                  checked={props.filterValue.updatedDate === "date"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      updatedDate: "date",
                    });
                  }}
                />
                Date Range
              </div>
            </div>
            {props.filterValue.updatedDate === "date" && (
              <div className="staff_referral_filter_detail_date">
                <div className="staff_referral_filter_detail_date_child">
                  <div>From</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.updated_on_start !== ""
                        ? new Date(props.filterValue.updated_on_start)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        updated_on_start: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
                <div className="staff_referral_filter_detail_date_child">
                  <div>To</div>
                  <DatePicker
                    dateFormatCalendar="MMMM"
                    customInput={<CustomDatePicker />}
                    // minDate={new Date()}
                    selected={
                      props.filterValue.updated_on_end !== ""
                        ? new Date(props.filterValue.updated_on_end)
                        : ""
                    }
                    onChange={(e) =>
                      props.setFilterValue({
                        ...props.filterValue,
                        updated_on_end: moment(e).format("YYYY-MM-DD"),
                      })
                    }
                  />
                </div>
              </div>
            )}
            {props.filterValue.updatedDate === "date"
              ? checkDateVali("updatedDate")
              : ""}
          </div>

          <div className="staff_referral_filter_check_box_main_box">
            <div className="staff_referral_filter_detail_title">Type</div>
            <div className="staff_referral_filter_radio_button_main_box_center">
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="type"
                  value="bus"
                  key="bus"
                  checked={props.filterValue.type === "bus"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      type: "bus",
                    });
                  }}
                />
                Bus
              </div>
              <div className="staff_referral_filter_radio_main_box">
                <RadioButton
                  className="Promotion_filter_Radio"
                  name="type"
                  value="rail"
                  key="rail"
                  checked={props.filterValue.type === "rail"}
                  onChange={(e) => {
                    props.setFilterValue({
                      ...props.filterValue,
                      type: "rail",
                    });
                  }}
                />
                Rail
              </div>
            </div>
          </div>
          <div className="staff_referral_filter_check_box_main_box">
            <div className="staff_referral_filter_detail_title">Position Applying</div>
            <DropDownList
              data={props.filterValue.type == "rail" ? railPositions : busPositions }
              value={props.filterValue.position || 'Select'}
              size={"large"}
              onChange={(e) => {
                props.setFilterValue({
                  ...props.filterValue,
                  position: e.target.value,
                });

              }}
              iconColor="#73007D"
              iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
            />
          </div>
          <div className="staff_referral_filter_check_box_main_box">
            <div className="staff_referral_filter_detail_title">Status</div>
            {allStatusConfig.map((i) => (
              <div key={i.id} className="Pormotions_filter_check_box_item">
                <Checkbox
                  style={{ border: "1px solid #CCC" }}
                  checked={props.filterValue.status.find((l) => l === i.id) ? true : false}
                  onClick={() => {
                    const find = props.filterValue.status.find((l) => l === i.id);
                    if (find) {
                      const filter = props.filterValue.status.filter((l) => l !== i.id);
                      props.setFilterValue({
                        ...props.filterValue,
                        status: filter,
                      });
                    } else {
                      props.setFilterValue({
                        ...props.filterValue,
                        status: [...props.filterValue.status, i.id],
                      });
                    }
                  }}
                />
                {i.name}
              </div>
            ))}

          </div>

        </div>
        <div className="staff_referral_filter_footer_main_box">
          <div
            className="staff_referral_filter_footer_cancel"
            onClick={() => props.setShowFilter(false)}
          >
            Cancel
          </div>
          <div
            className="staff_referral_filter_footer_submit"
            onClick={props.FilterAction}
          >
            Submit
          </div>
        </div>
      </div>
    </Dialog>
  );
};
